/*
  src/redux/impersonate/constants.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'impersonate', action].join('/');
}

export const TOKEN_LOADED_FROM_COOKIE = createConstant('TOKEN_LOADED_FROM_COOKIE');
export const TOKEN_FAILED_TO_LOAD_FROM_COOKIE = createConstant('TOKEN_FAILED_TO_LOAD_FROM_COOKIE');
export const TOKEN_REQUESTED = createConstant('TOKEN_REQUESTED');
export const TOKEN_LOADED = createConstant('TOKEN_LOADED');
export const TOKEN_FAILED_TO_LOAD = createConstant('TOKEN_FAILED_TO_LOAD');
export const TOKEN_INVALIDATED = createConstant('TOKEN_INVALIDATED');
export const IMPERSONATION_CEASED = createConstant('IMPERSONATION_CEASED')



// WEBPACK FOOTER //
// ./src/shared/redux/impersonate/constants.js